<div class="destination-tab">
  <!-- Destinations -->
  <div class="destination-tab__section">
    <h3 class="destination-tab__section-title">
      Destinations
      <span class="destination-tab__section-caption">{{ selectedIds.length }} selected</span>
    </h3>
    <div class="destination-tab__destinations">
      <div
        *ngFor="let account of destinations"
        class="destination-tab__destination-card"
        [class.destination-tab__destination-card--selected]="isSelected(account.id)"
      >
        <div
          class="destination-tab__destination-row"
          (click)="toggleDestination(account.id)"
        >
          <div
            class="destination-tab__destination-check"
            [class.destination-tab__destination-check--checked]="isSelected(account.id)"
          >
            <span *ngIf="isSelected(account.id)" class="destination-tab__check-icon">✓</span>
          </div>
          <div class="destination-tab__destination-body">
            <div class="destination-tab__destination-head">
              <span class="destination-tab__destination-icon-wrap" [ngClass]="account.iconCssClass">
                <span [inlineSVG]="account.icon" class="destination-tab__destination-icon" aria-hidden="true"></span>
              </span>
              <span class="destination-tab__destination-name">{{ account.name }}</span>
              <button
                *ngIf="isSelected(account.id) && !account.unavailable"
                type="button"
                class="destination-tab__destination-expand-btn"
                (click)="toggleExpanded(account.id, $event)"
              >
                <span [class.destination-tab__chevron--open]="isExpanded(account.id)">▼</span>
              </button>
            </div>
            <div
              *ngIf="isSelected(account.id) && !isExpanded(account.id) && !account.unavailable"
              class="destination-tab__destination-summary"
            >
              {{ getConfig(account.id).aspectRatio }}
            </div>
          </div>
        </div>

        <!-- Expanded settings -->
        <div *ngIf="isSelected(account.id) && isExpanded(account.id) && !account.unavailable" class="destination-tab__destination-expanded">
          <div class="destination-tab__expanded-inner">
            <div class="destination-tab__grid">
              <div class="destination-tab__field destination-tab__field--aspect-ratio">
                <label class="destination-tab__label">Aspect Ratio</label>
                <icn-dropdown
                  class="destination-tab__dropdown destination-tab__dropdown--aspect-ratio"
                  [large]="true"
                  [allowMultiple]="false"
                  [listDown]="true"
                  [selectedValue]="getConfig(account.id).aspectRatio"
                  (selectedValueChange)="onAspectRatioChange(account.id, $event)"
                >
                  <icn-dropdown-item title="16:9" value="16:9"></icn-dropdown-item>
                  <icn-dropdown-item title="9:16" value="9:16"></icn-dropdown-item>
                  <icn-dropdown-item title="1:1" value="1:1"></icn-dropdown-item>
                  <icn-dropdown-item title="4:3" value="4:3"></icn-dropdown-item>
                </icn-dropdown>
              </div>
            </div>

            <ng-container *ngIf="canViewDestinationSettings">
              <ng-container *ngIf="destinationSettingsState(account.id) as ds">
                <div
                  *ngIf="isTikTokPlatform(ds.platform) && hasDisabledTikTokInteractions(ds.creatorInfo)"
                  class="destination-tab__notice"
                >
                  Some TikTok interaction settings are unavailable because they are disabled in this TikTok account.
                </div>
              </ng-container>
            </ng-container>

            <div class="destination-tab__field-group">
              <div *ngIf="!canViewDestinationSettings" class="destination-tab__readonly">
                You don’t have permission to view destination settings.
              </div>

              <ng-container *ngIf="canViewDestinationSettings">
                <ng-container *ngIf="destinationSettingsState(account.id) as ds">
                  <div
                    *ngIf="ds.panelState === 'idle' || ds.panelState === 'loading'"
                    class="destination-tab__graphic-loading"
                  >
                    Loading destination settings…
                  </div>
                  <div
                    *ngIf="ds.panelState === 'error'"
                    class="destination-tab__graphic-error"
                  >
                    {{ ds.errorMessage }}
                  </div>

                  <ng-container *ngIf="ds.panelState === 'ready'">
                    <ng-container *ngIf="ds.details as details">
                      <evrideo-clipping-studio-tiktok-publish-settings
                        *ngIf="isTikTokPlatform(ds.platform)"
                        [destinationUid]="account.id"
                        [destinationName]="account.name"
                        [creatorInfo]="ds.creatorInfo"
                        [platformData]="asTikTokPlatformData(ds.draftPlatformData)"
                        [readonly]="false"
                        (platformDataChange)="onDestinationSettingsDraftChange(account.id, $event); publishState.setDestinationSettingsOverride(account.id, $event)"
                      ></evrideo-clipping-studio-tiktok-publish-settings>

                      <evrideo-clipping-studio-facebook-publish-settings
                        *ngIf="isFacebookPlatform(ds.platform)"
                        [destinationUid]="account.id"
                        [destinationName]="account.name"
                        [destinationDefaults]="asFacebookDestinationDefaults(ds.details)"
                        [publicationSettings]="asFacebookPublicationSettings(account.id, asFacebookDestinationDefaults(ds.details))"
                        [readonly]="!canEditDestinationSettings"
                        (platformDataChange)="onFacebookSettingsChange(account.id, $event)"
                      ></evrideo-clipping-studio-facebook-publish-settings>

                      <evrideo-clipping-studio-instagram-publish-settings
                        *ngIf="isInstagramPlatform(ds.platform)"
                        [destinationUid]="account.id"
                        [destinationName]="account.name"
                        [destinationDefaults]="asInstagramDestinationDefaults(ds.details)"
                        [publicationSettings]="asInstagramPublicationSettings(account.id, asInstagramDestinationDefaults(ds.details))"
                        [readonly]="!canEditDestinationSettings"
                        (platformDataChange)="onInstagramSettingsChange(account.id, $event)"
                      ></evrideo-clipping-studio-instagram-publish-settings>

                      <evrideo-clipping-studio-youtube-publish-settings
                        *ngIf="isYouTubePlatform(ds.platform) && ds.videoCategories"
                        [destinationUid]="account.id"
                        [catalog]="ds.videoCategories"
                        [platformData]="asYouTubePublicationSettings(account.id, asYouTubeDestinationDefaults(details))"
                        [readonly]="!canEditDestinationSettings"
                        (platformDataChange)="onYouTubeSettingsChange(account.id, $event)"
                      ></evrideo-clipping-studio-youtube-publish-settings>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="destination-tab__spacer"></div>
</div>
